import React, { Component } from "react";
import ReactDOM from "react-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./styles.css";

const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

const getFirstAndLastName = (fullName) => {
  if (!fullName) return '';

  const nameParts = fullName.trim().split(/\s+/);

  if (nameParts.length === 1) {
    return nameParts[0];
  } else {
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];
    return `${firstName} ${lastName}`;
  }
};

const getListStyle = (isDraggingOver) => ({
  padding: "8px 8px 0px 8px",
  width: 300,
  minHeight: 100,
  borderRadius: "3px",
  marginRight: "8px",
  boxShadow: isDraggingOver
    ? "0px 4px 10px rgba(0, 0, 0, 0.25)"
    : "0px 2px 5px rgba(0, 0, 0, 0.1)",
  border: isDraggingOver ? "3px solid #892fc4" : "3px solid transparent",
  transition: "box-shadow 0.2s ease-in-out, border 0.2s ease-in-out",
});

const initialData = {
  lanes: [
    {
      id: "lane-1",
      title: "",
      backgroundColor: "#f0f0f0",
      cards: [],
    },
    {
      id: "lane-2",
      title: "",
      backgroundColor: "#f0f0f0",
      cards: [],
    },
    {
      id: "lane-3",
      title: "",
      backgroundColor: "#f0f0f0",
      cards: [],
    },
    {
      id: "lane-4",
      title: "",
      backgroundColor: "#f0f0f0",
      cards: [],
    },
    {
      id: "lane-5",
      title: "",
      backgroundColor: "#f0f0f0",
      cards: [],
    }
  ],
};

class QuoteApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lanes: initialData.lanes,
      sistemas: [],
      clientes: [],
      colaboradores: [],
      selectedSistema: "",
      selectedSetor: "",
      selectedCliente: "",
      laneOrder: [],
      ColaboradorId: "",
      setorLocked: false,
      colaboradorLocked: false,
      isAdmUser: false,
      isLoading: false, // Estado para o loading
    };

    this.onDragEnd = this.onDragEnd.bind(this);
    this.handleCardDoubleClick = this.handleCardDoubleClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateCardPosition = this.updateCardPosition.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.fetchSistemas = this.fetchSistemas.bind(this);
    this.fetchClientes = this.fetchClientes.bind(this);
    this.fetchColaboradores = this.fetchColaboradores.bind(this);
    this.fetchLanes = this.fetchLanes.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const colaboradorId = params.get('c');
    const setor = params.get('s');

    const newState = {
      ColaboradorId: colaboradorId || "",
    };

    if (setor) {
      newState.selectedSetor = setor;
      newState.setorLocked = true;
    }

    if (colaboradorId) {
      newState.colaboradorLocked = true;
    }

    newState.isAdmUser = colaboradorId ? false : true;

    this.setState(newState, () => {
      Promise.all([
        this.fetchSistemas(),
        this.fetchClientes(),
        colaboradorId ? Promise.resolve() : this.fetchColaboradores(),
      ])
        .then(() => {
          this.fetchLanes();
        })
        .catch((error) => {
          console.error("Erro ao buscar filtros iniciais:", error);
        });
    });

    this.interval = setInterval(() => {
      console.log('Atualizando detalhes do chamado');
      this.fetchLanes();
    }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchChamadoDetails = async (chamadoId) => {
    try {
      const response = await fetch("https://proxy.sistemastega.com.br/proxy", {
        method: "GET",
        headers: {
          "URL_API": `https://suporte.tegasistemas.com.br/suporteTEGA/kanban/Chamadodata?Chamadoid=${chamadoId}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar detalhes do chamado: ${response.statusText}`);
      }

      const data = await response.json();
      this.setState({ chamadoDetails: data });
    } catch (error) {
      console.error("Erro ao buscar detalhes do chamado:", error);
    }
  };

  async fetchSistemas() {
    try {
      const response = await fetch('https://proxy.sistemastega.com.br/proxy', {
        method: 'GET',
        headers: {
          'URL_API': 'https://suporte.tegasistemas.com.br/suporteTEGA/kanban/sistemas',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar sistemas: ${response.statusText}`);
      }
      const data = await response.json();
      this.setState({ sistemas: data.sistemas });
    } catch (error) {
      console.error("Erro ao buscar sistemas:", error);
    }
  }

  async fetchClientes() {
    try {
      const response = await fetch('https://proxy.sistemastega.com.br/proxy', {
        method: 'GET',
        headers: {
          'URL_API': 'https://suporte.tegasistemas.com.br/suporteTEGA/kanban/clientes',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar clientes: ${response.statusText}`);
      }
      const data = await response.json();

      if (data.clientes && data.clientes.length > 0) {
        this.setState({ clientes: data.clientes });
      } else {
        this.setState({ clientes: [] });
      }
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    }
  }

  async fetchColaboradores() {
    try {
      const response = await fetch('https://proxy.sistemastega.com.br/proxy', {
        method: 'GET',
        headers: {
          'URL_API': 'https://suporte.tegasistemas.com.br/suporteTEGA/kanban/colaboradores',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar colaboradores: ${response.statusText}`);
      }
      const data = await response.json();
      if (data.colaboradores.length > 0) {
        this.setState({ colaboradores: data.colaboradores });
      } else {
        this.setState({ colaboradores: [] });
      }

    } catch (error) {
      console.error("Erro ao buscar colaboradores:", error);
    }
  }

  async fetchLanes() {
    const { selectedSistema, selectedSetor, selectedCliente, ColaboradorId } = this.state;
    const apiUrl = 'https://suporte.tegasistemas.com.br/suporteTEGA/kanban/data';

    const params = new URLSearchParams();
    params.append('Setorfiltro', selectedSetor);
    if (selectedSistema) params.append('Softwareid', selectedSistema);
    if (selectedSetor) params.append('Setorfiltro', selectedSetor);
    if (ColaboradorId) params.append('Colaboradorid', ColaboradorId);
    if (selectedCliente) params.append('Clienteid', selectedCliente);

    try {
      //this.setState({ isLoading: true }); // Ativar o loading antes de buscar os dados

      const response = await fetch('https://proxy.sistemastega.com.br/proxy', {
        method: 'GET',
        headers: {
          'URL_API': `${apiUrl}?${params.toString()}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Erro na resposta da rede: ${response.statusText}`);
      }

      const data = await response.json();

      const lanesWithCards = (data.lanes || []).map(lane => ({
        ...lane,
        cards: lane.cards || [],
      }));

      this.setState({
        lanes: lanesWithCards,
        laneOrder: data.laneOrder || [],
      });
    } catch (error) {
      console.error('Erro ao buscar dados via proxy:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  handleFilterChange(event) {
    const { name, value } = event.target;
    this.setState(
      { [name]: value },
      () => {
        this.setState({ isLoading: true });
        this.fetchLanes();
        this.setState({ isLoading: false });
      }
    );
  }

  updateCardPosition = async (cardId, newLaneId, newPosition) => {
    function toInteger(value, fieldName) {
      const parsed = parseInt(value, 10);
      if (isNaN(parsed)) {
        throw new Error(`O campo ${fieldName} deve ser um número inteiro válido.`);
      }
      return parsed;
    }

    try {
      const sendData = {
        ChamadoId: toInteger(cardId, 'ChamadoId'),
        TipoServicoId: toInteger(newLaneId, 'TipoServicoId'),
      };

      await fetch('https://proxy.sistemastega.com.br/proxy', {
        method: 'POST',
        headers: {
          'URL_API': 'https://suporte.tegasistemas.com.br/suporteTEGA/kanban/setlane',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(sendData),
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => { throw new Error(err.error || 'Erro na resposta da rede'); });
          }
          return response.json();
        })
        .then(data => {
        })
        .catch(error => {
          console.error("Erro ao atualizar posição do card:", error);
        });

    } catch (error) {
      console.error("Erro no try-catch:", error);
    }
  };

  onDragEnd(result) {
    const { source, destination, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    const lanes = Array.from(this.state.lanes);
    const startLaneIndex = lanes.findIndex(lane => lane.id === source.droppableId);
    const finishLaneIndex = lanes.findIndex(lane => lane.id === destination.droppableId);

    const startLane = lanes[startLaneIndex];
    const finishLane = lanes[finishLaneIndex];

    if (startLane === finishLane) {
      const newCards = Array.from(startLane.cards);
      const [movedCard] = newCards.splice(source.index, 1);
      newCards.splice(destination.index, 0, movedCard);

      const newLane = {
        ...startLane,
        cards: newCards,
      };

      lanes[startLaneIndex] = newLane;

      this.setState({ lanes });
      return;
    }

    const startCards = Array.from(startLane.cards);
    const [movedCard] = startCards.splice(source.index, 1);
    const finishCards = Array.from(finishLane.cards);
    finishCards.splice(destination.index, 0, movedCard);

    const newStartLane = {
      ...startLane,
      cards: startCards,
    };

    const newFinishLane = {
      ...finishLane,
      cards: finishCards,
    };

    lanes[startLaneIndex] = newStartLane;
    lanes[finishLaneIndex] = newFinishLane;

    this.setState({ lanes }, () => {
      this.updateCardPosition(
        draggableId,
        newFinishLane.id,
        destination.index
      );
    });
  }

  handleCardDoubleClick(card) {
    this.setState(
      {
        modalVisible: true,
        selectedCard: card,
        chamadoDetails: null,
      },
      () => {
        this.fetchChamadoDetails(card.id);
      }
    );
  }

  closeModal() {
    this.setState({
      modalVisible: false,
      selectedCard: null,
    });
  }

  renderModal() {
    const { modalVisible, chamadoDetails } = this.state;

    if (!modalVisible) return null;

    return (
      <div className="modal-backdrop" onClick={this.closeModal}>
        <div
          className="modal"
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "600px", // Largura máxima do modal
            width: "90%", // Responsivo em telas menores
            maxHeight: "80vh", // Limite de altura
            overflow: "hidden", // Previne estouro do conteúdo
            padding: "30px", // Espaçamento interno
            borderRadius: "10px", // Borda arredondada
            backgroundColor: "white",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
          }}
        >
          <h2 style={{ marginBottom: "20px" }}>Detalhes do Chamado</h2>
          <div
            style={{
              maxHeight: "60vh", // Limita a altura da área de conteúdo
              overflowY: "auto", // Adiciona barra de rolagem vertical quando necessário
              paddingRight: "10px", // Para evitar que o conteúdo toque na borda
            }}
          >
            {chamadoDetails ? (
              <div>
                <div style={{ marginBottom: "15px" }}>
                  <label><strong>Nro. Chamado</strong></label>
                  <p>{chamadoDetails.ChamadoId}</p>
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label><strong>Descrição</strong></label>
                  <p>{chamadoDetails.ChamadoDescricao}</p>
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label><strong>Descrição Completa</strong></label>
                  <p style={{ whiteSpace: "pre-wrap" }}>{chamadoDetails.ChamadoDescricaoCompleta}</p>
                </div>
                {/* Alinhamento em colunas */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "15px",
                  }}
                >
                  <div style={{ flex: 1, marginRight: "10px" }}>
                    <label><strong>Solicitante</strong></label>
                    <p>{chamadoDetails.ChamadoSolicitante}</p>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label><strong>Cliente</strong></label>
                    <p>{chamadoDetails.ClienteNome}</p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "15px",
                  }}
                >
                  <div style={{ flex: 1, marginRight: "10px" }}>
                    <label><strong>Módulo</strong></label>
                    <p>{chamadoDetails.ModuloNome}</p>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label><strong>Prioridade</strong></label>
                    <p>{chamadoDetails.PrioridadeDescricao}</p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "15px",
                  }}
                >
                  <div style={{ flex: 1, marginRight: "10px" }}>
                    <label><strong>Data de Cadastro</strong></label>
                    <p>{chamadoDetails.ChamadoDtCadastro}</p>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label><strong>Forma do Chamado</strong></label>
                    <p>{chamadoDetails.FormaChamadoDescricao}</p>
                  </div>
                </div>
              </div>
            ) : (
              <p>Carregando detalhes...</p>
            )}
          </div>
          <button
            onClick={this.closeModal}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    );
  }

  render() {
    const {
      lanes,
      isLoading,
      sistemas,
      clientes,
      colaboradores,
      selectedSistema,
      selectedSetor,
      selectedCliente,
      setorLocked,
      colaboradorLocked,
      ColaboradorId,
      isAdmUser,
    } = this.state;

    const shouldShowFilter = isAdmUser;

    return (
      <div className="app-container">
        {isLoading && (
          <div className="loading-indicator">
            <div className="spinner"></div>
          </div>
        )}
        <div className="scroll-container">
          {shouldShowFilter && (
            <div className="filter-container">
              <div className="filter-item">
                <label htmlFor="selectedSistema" className="filter-label">
                  Sistema:
                </label>
                <select
                  id="selectedSistema"
                  name="selectedSistema"
                  value={selectedSistema}
                  onChange={this.handleFilterChange}
                  className="filter-select"
                >
                  <option value="">Todos</option>
                  {sistemas.map((sistema) => (
                    <option key={sistema.id} value={sistema.id}>
                      {sistema.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-item">
                <label htmlFor="selectedSetor" className="filter-label">
                  Setor:
                </label>
                <select
                  id="selectedSetor"
                  name="selectedSetor"
                  value={selectedSetor}
                  onChange={this.handleFilterChange}
                  disabled={setorLocked}
                  className="filter-select"
                >
                  <option value="">Todos</option>
                  <option value="D">Desenvolvimento</option>
                  <option value="S">Suporte</option>
                </select>
              </div>

              <div className="filter-item">
                <label htmlFor="selectedCliente" className="filter-label">
                  Cliente:
                </label>
                <select
                  id="selectedCliente"
                  name="selectedCliente"
                  value={selectedCliente}
                  onChange={this.handleFilterChange}
                  className="filter-select"
                >
                  <option value="">Todos</option>
                  {clientes.map((cliente) => (
                    <option key={cliente.id} value={cliente.id}>
                      {cliente.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-item">
                <label htmlFor="ColaboradorId" className="filter-label">
                  Colaborador:
                </label>
                <select
                  id="ColaboradorId"
                  name="ColaboradorId"
                  value={ColaboradorId}
                  onChange={this.handleFilterChange}
                  disabled={colaboradorLocked}
                  className="filter-select"
                >
                  <option value="">Todos</option>
                  {colaboradores.map((colaborador) => (
                    <option key={colaborador.id} value={colaborador.id}>
                      {colaborador.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <div>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <div style={{ display: isLoading ? "none" : "flex" }}>
                {lanes.map((lane) => (
                  <div key={lane.id} className="column-lane">
                    <h3 className="lane-title">{lane.title}</h3>
                    <Droppable droppableId={lane.id}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="lane"
                          style={{
                            ...getListStyle(snapshot.isDraggingOver),
                            backgroundColor: lane.backgroundColor || "#ebecf0",
                          }}
                        >
                          {lane.cards.map((card, index) => (
                            <Draggable
                              key={card.id}
                              draggableId={card.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className="card"
                                  style={{
                                    ...provided.draggableProps.style,
                                  }}
                                  onDoubleClick={() =>
                                    this.handleCardDoubleClick(card)
                                  }
                                >
                                  <div className="card-content">
                                    <h4 className="card-title">{card.title}</h4>
                                    <b className="card-description">
                                      {card.id} - {card.cliente}
                                    </b>
                                    <div className="description-container">
                                      <p className="card-description">
                                        {card.description}
                                      </p>
                                    </div>
                                    <p className="card-title">
                                      {truncateText(
                                        getFirstAndLastName(card.Tecnico),
                                        20
                                      )}
                                    </p>
                                    <p className="card-smalldescription">
                                      Encaminhado: {card.DtEncaminhado}
                                    </p>
                                    <p className="card-smalldescription">
                                      Espera: {card.TempoEspera} / Versão: {card.version}
                                    </p>
                                    <p className="card-smalldescription">
                                      Min. Previstos: {card.MinPrevisto || 0} {card.MinutosOrcado > 0 ? `/ Orçados: ${card.MinutosOrcado}` : ``}
                                    </p>
                                  </div>
                                  <img
                                    src={card.image}
                                    alt="Sistema"
                                    className="card-image"
                                  />
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                ))}
              </div>
            </DragDropContext>
          </div>
        </div>
        {this.renderModal()}
      </div>
    );
  }

}

const rootElement = document.getElementById("root");
ReactDOM.render(<QuoteApp />, rootElement);
